import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { SharedService } from '../../../../../shared/shared.service';
import { VehicleService } from '../../vehicle.service';


@Component({
  selector: 'app-vehicle',
  templateUrl: './vehicle.component.html',
  styleUrls: ['./vehicle.component.css']
})
export class VehicleComponent implements OnInit {

  dataSource;
  sessionId = sessionStorage.getItem('com-session-id');

  constructor(
    public sharedService: SharedService,
    private httpClient: HttpClient,
    public vehicle: VehicleService
  ) { }

  ngOnInit() {
    this.sharedService.loadingActive = true;
    // tslint:disable-next-line:max-line-length
    this.httpClient.get<any>(`${this.sharedService.URL}/dbVehicle?SessionID=${this.sessionId}&Search=*`).subscribe(Response => {
      this.dataSource = Response.dbVehicle_response.view;
      this.sharedService.loadingActive = false;
    });
    this.sharedService.loadingActive = false;
  }

  clickEdit(data) {
    this.vehicle.setPayment(0);
    sessionStorage.setItem('vehicle-id', data);
  }
  clickNew() {
    this.vehicle.setPayment(1);
  }
}
